// import { useState, FormEvent, useEffect } from 'react'

import cn from 'classnames'

// import { FORMBOLD_ENDPOINT } from '@/constants/api'

import { ContactsProps } from './Contacts.types'

// declare global {
//     interface Window {
//         Calendly?: {
//             initPopupWidget: (options: { url: string }) => void
//         }
//     }
// }

export const Contacts = (props: ContactsProps) => {
    const { className } = props
    // const [isSubmitting, setIsSubmitting] = useState(false)
    // const [submitStatus, setSubmitStatus] = useState<'success' | 'error' | null>(null)

    // useEffect(() => {
    //     const script = document.createElement('script')
    //     script.src = 'https://assets.calendly.com/assets/external/widget.js'
    //     script.async = true
    //     document.body.appendChild(script)

    //     return () => {
    //         document.body.removeChild(script)
    //     }
    // }, [])

    // const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    //     e.preventDefault()
    //     setIsSubmitting(true)
    //     setSubmitStatus(null)

    //     const form = e.currentTarget
    //     const formData = new FormData(form)

    //     try {
    //         const response = await fetch(FORMBOLD_ENDPOINT, {
    //             method: 'POST',
    //             body: formData,
    //         })

    //         if (response.ok || response.status === 200) {
    //             form.reset()
    //             setSubmitStatus('success')
    //         } else {
    //             setSubmitStatus('error')
    //         }
    //     } catch (error) {
    //         console.error('Form submission error:', error)
    //         setSubmitStatus('error')
    //     } finally {
    //         setIsSubmitting(false)
    //     }
    // }

    // const onSubmitWrapper = (e: FormEvent<HTMLFormElement>) => {
    //     handleSubmit(e).catch(() => {
    //         setSubmitStatus('error')
    //     })
    // }

    // const openCalendly = () => {
    //     if (window.Calendly) {
    //         window.Calendly.initPopupWidget({
    //             url: 'https://calendly.com/alek-4elf/nexly-demo',
    //         })
    //     }
    // }

    return (
        <section className={cn('py-24 md:py-32 bg-gradient-to-b from-gray-50 to-white', className)}>
            <div className='container mx-auto px-4 max-w-4xl'>
                <div className='text-center mb-16'>
                    <p className='text-sm uppercase tracking-wider text-gray-500 mb-4'>contact us</p>
                    <h1 className='text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6'>
                        Streamline financial reviews with Nexly
                    </h1>
                    <p className='text-lg text-gray-600 max-w-2xl mx-auto'>
                        Experience the ultimate tool for financial statement review automation, designed for accuracy and efficiency
                    </p>
                </div>

                <div className='bg-white rounded-lg shadow-lg p-8 md:p-12 text-center'>
                    <div className='max-w-2xl mx-auto'>
                        <h2 className='text-2xl font-bold text-gray-900 mb-4'>
                            Thank You for Your Interest
                        </h2>
                        <p className='text-lg text-gray-600 mb-8'>
                            We are not accepting new demo or trial requests at this time. For partnership opportunities or general inquiries, reach out to us directly.
                        </p>
                        <div className='pt-8 border-t border-gray-200'>
                            <p className='text-gray-600 mb-2'>Contact us at</p>
                            <a
                                href='mailto:contact@nexly.tech'
                                className='text-primary hover:text-primary-hover text-xl font-semibold transition-colors'
                            >
                                contact@nexly.tech
                            </a>
                        </div>
                    </div>
                </div>

                {/* Calendly and Form - commented out */}
                {/* <div className='bg-white rounded-lg shadow-lg p-8 md:p-12'>
                    <div className='text-center mb-8'>
                        <button
                            type='button'
                            onClick={openCalendly}
                            className='inline-flex items-center justify-center w-full sm:w-auto h-14 px-10 font-semibold tracking-wide transition duration-200 rounded-lg shadow-lg bg-white text-primary border-2 border-primary hover:bg-gray-50 focus:shadow-outline focus:outline-none text-lg'
                        >
                            <svg
                                className='w-5 h-5 mr-3'
                                fill='none'
                                stroke='currentColor'
                                viewBox='0 0 24 24'
                                xmlns='http://www.w3.org/2000/svg'
                            >
                                <path
                                    strokeLinecap='round'
                                    strokeLinejoin='round'
                                    strokeWidth={2}
                                    d='M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z'
                                />
                            </svg>
                            Schedule a Demo
                        </button>
                    </div>

                    <div className='relative my-8'>
                        <div className='absolute inset-0 flex items-center'>
                            <div className='w-full border-t border-gray-300'/>
                        </div>
                        <div className='relative flex justify-center text-sm'>
                            <span className='px-4 bg-white text-gray-500'>or send us a message</span>
                        </div>
                    </div>

                    {submitStatus === 'success' ? (
                        <div className='p-8 bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-300 rounded-2xl'>
                            <div className='flex items-center justify-center mb-4'>
                                <div className='w-16 h-16 bg-green-500 rounded-full flex items-center justify-center'>
                                    <svg
                                        className='w-10 h-10 text-white'
                                        fill='none'
                                        stroke='currentColor'
                                        viewBox='0 0 24 24'
                                    >
                                        <path
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                            strokeWidth={3}
                                            d='M5 13l4 4L19 7'
                                        />
                                    </svg>
                                </div>
                            </div>
                            <h3 className='text-2xl font-bold text-green-900 text-center mb-2'>
                                Message Sent Successfully!
                            </h3>
                            <p className='text-green-700 text-center text-lg'>
                                Thank you for reaching out. We'll get back to you shortly.
                            </p>
                        </div>
                    ) : (
                        <form onSubmit={onSubmitWrapper} className='space-y-6'>
                            <div>
                                <label htmlFor='email' className='block text-sm font-medium text-gray-700 mb-2'>
                                    Email
                                </label>
                                <input
                                    type='email'
                                    id='email'
                                    name='email'
                                    required
                                    className='w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-colors'
                                    placeholder='your.email@example.com'
                                />
                            </div>

                            <div>
                                <label htmlFor='subject' className='block text-sm font-medium text-gray-700 mb-2'>
                                    Subject
                                </label>
                                <input
                                    type='text'
                                    id='subject'
                                    name='subject'
                                    required
                                    className='w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-colors'
                                    placeholder='Subject'
                                />
                            </div>

                            <div>
                                <label htmlFor='message' className='block text-sm font-medium text-gray-700 mb-2'>
                                    Message
                                </label>
                                <textarea
                                    id='message'
                                    name='message'
                                    required
                                    rows={6}
                                    className='w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-colors resize-none'
                                    placeholder='Your message...'
                                />
                            </div>

                            {submitStatus === 'error' && (
                                <div className='p-4 bg-red-50 border border-red-200 rounded-lg text-red-800'>
                                    Something went wrong. Please try again later.
                                </div>
                            )}

                            <button
                                type='submit'
                                disabled={isSubmitting}
                                className='inline-flex items-center justify-center w-full h-12 px-6 font-medium tracking-wide text-white transition duration-200 rounded shadow-md bg-primary hover:bg-primary-hover focus:shadow-outline focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed'
                            >
                                {isSubmitting ? 'Sending...' : 'Send Message'}
                            </button>
                        </form>
                    )}

                    <div className='mt-12 pt-12 border-t border-gray-200 text-center'>
                        <p className='text-gray-600 mb-2'>Or reach us directly at</p>
                        <a
                            href='mailto:contact@nexly.tech'
                            className='text-primary hover:text-primary-hover text-lg font-semibold transition-colors'
                        >
                            contact@nexly.tech
                        </a>
                    </div>
                </div> */}
            </div>
        </section>
    )
}
